import { readSessionItem, writeSessionItem } from 'lib/safeSessionStorage';
import { Location } from 'slices/locationSlice';

const BROWSE_USER_ID_KEY = 'browseUserId';
const CACHED_LOCATION_KEY = 'cachedLocation';

export function setBrowseUserId(userId: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  writeSessionItem(BROWSE_USER_ID_KEY, userId);
}

export function getBrowseUserId(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return readSessionItem(BROWSE_USER_ID_KEY) ?? undefined;
}

export function getCachedLocation(): Location | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const cached = readSessionItem(CACHED_LOCATION_KEY);
  if (!cached) {
    return undefined;
  }

  try {
    return JSON.parse(cached) as Location;
  } catch {
    return undefined;
  }
}
